export default "__VITE_ASSET__C75$0m5d__"